import React, { createContext, useState, useContext, useEffect } from "react";

// --------------------------------------------------
// Context
// --------------------------------------------------
const KriterienContext = createContext();

// Custom hook
export const useKriterien = () => {
  const context = useContext(KriterienContext);
  if (!context)
    throw new Error("useKriterien must be used within KriterienProvider");
  return context;
};

// --------------------------------------------------
// Provider
// --------------------------------------------------
export const KriterienProvider = ({ children }) => {
  const [data, setData] = useState(() => {
    const saved = localStorage.getItem("kriterien");
    if (saved) {
      return JSON.parse(saved);
    }
    return {
      orthopaedischeZusatzkomplikation: "",
      neurologischeZusatzkomplikation: "",
      fehlgeschlageneVorversorgung: "",
      KriterienNotiz: "",
    };
  });

  // Persist on update
  useEffect(() => {
    localStorage.setItem("kriterien", JSON.stringify(data));
  }, [data]);

  // Reset function – updated to match the new fields
  const clearKriterien = () => {
    setData({
      orthopaedischeZusatzkomplikation: "",
      neurologischeZusatzkomplikation: "",
      fehlgeschlageneVorversorgung: "",
      KriterienNotiz: "",
    });
    localStorage.removeItem("kriterien");
  };

  return (
    <KriterienContext.Provider value={{ data, setData, clearKriterien }}>
      {children}
    </KriterienContext.Provider>
  );
};
